import { useModalContext } from 'utils/contexts/modal';

export enum ROLE_CONFIGURATION_ACTION {
  CREATE_ROLE = 'create-role',
  UNSAVED_CHANGES = 'unsaved-changes',
}

export interface ModalState {
  action: ROLE_CONFIGURATION_ACTION;
}

export type ModalContextState = {
  showModal: (modalState: ModalState) => void;
  hideModal: () => void;
  modalState: ModalState | null;
};

export const useRolesModalsContext = () => {
  const { showModal, hideModal, modalState } = useModalContext<ModalState>();

  const showCreateRoleModal = () =>
    showModal({
      action: ROLE_CONFIGURATION_ACTION.CREATE_ROLE,
    });

  const showUnsavedChangesModal = () => {
    showModal({
      action: ROLE_CONFIGURATION_ACTION.UNSAVED_CHANGES,
    });
  };

  return {
    showCreateRoleModal,
    showUnsavedChangesModal,
    hideModal,
    modalState,
  };
};
